import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from 'app/models/alert.model';

@Component({
  selector: 'app-selected-alert',
  templateUrl: './selected-alert.component.html',
  styleUrls: ['./selected-alert.component.scss']
})
export class SelectedAlertComponent implements OnInit {

  @Input()
  selectedAlert: Alert = null;


  constructor(
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Get time difference between creation date of given alert and now
   * @returns 
   */
  getTimeDifference(alertDate: Date): string {
    const now = Date.now();
    // get total seconds between the times
    var delta = Math.abs(now - alertDate.getTime()) / 1000;
    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;    
    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;    
    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    return days + ' ' + this.translate.instant('alerts.alert_issued_date.days', {s: days > 1 ? 's' : ''}) + ' ' + hours.toString().padStart(2, '0') + ' ' + this.translate.instant('alerts.alert_issued_date.hours', {s: hours > 1 ? 's' : ''}) + ' ' + minutes.toString().padStart(2, '0') + ' ' + this.translate.instant('alerts.alert_issued_date.minutes', {s: minutes > 1 ? 's' : ''});
  }

}
